import { ComponentType, SVGProps } from 'react';
import { TimerIcon, UsersIcon, MapPinIcon } from '../icons';

/**
 * Catalogo de aplicaciones de la Suite LCC, mostradas como tarjetas en el
 * Selector de Aplicacion (pantalla de entrada, despues del login). Debe
 * coincidir con los Code de apps/api/src/shared/applications.ts y con
 * Esq_Configuration.TB_Configuration_Application.
 *
 * Para agregar una aplicacion nueva: (1) una entrada aqui, (2) su Code en el
 * backend, (3) su fila en TB_Configuration_Application. Ninguna aplicacion
 * existente se modifica en el proceso (principio Open/Closed de la Suite).
 *
 * NOTA - "turno-geo": por ahora es solo la tarjeta de entrada (este archivo).
 * Aun no tiene Code en el backend ni fila en TB_Configuration_Application, asi
 * que ningun usuario tiene acceso todavia y la tarjeta se muestra deshabilitada
 * ("Sin acceso") a proposito, hasta que se apruebe el documento de arquitectura
 * y se decida iniciar el desarrollo (ver Documento de Arquitectura TurnoGeo).
 */
export type ApplicationCode = 'control-operativo' | 'gestion-humana' | 'turno-geo';

export interface ApplicationDefinition {
  code: ApplicationCode;
  name: string;
  description: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Ruta raiz de esta aplicacion dentro del router de la Suite. */
  homePath: string;
}

export const APPLICATIONS: ApplicationDefinition[] = [
  {
    code: 'control-operativo',
    name: 'Control Operativo',
    description: 'Tiempos, reportes y auditoría de la operación logística',
    icon: TimerIcon,
    homePath: '/control-operativo',
  },
  {
    code: 'gestion-humana',
    name: 'Gestión Humana',
    description: 'Horas extra, recargos y novedades de nómina',
    icon: UsersIcon,
    homePath: '/gestion-humana',
  },
  {
    code: 'turno-geo',
    name: 'TurnoGeo',
    description: 'Registro geolocalizado de entrada y salida',
    icon: MapPinIcon,
    homePath: '/turno-geo',
  },
];
